import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const MoonIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="moon" ref={ref} {...props}>
      <path d="M12.72,21.45a9.78,9.78,0,0,1-8.26-4.33C1.47,12.55,3,6.23,7.86,3A11,11,0,0,1,11,1.63a.73.73,0,0,1,.84.34.74.74,0,0,1-.11.91,8,8,0,0,0-1.27,9.63h0a8,8,0,0,0,10.15,3.38.76.76,0,0,1,.89.23.75.75,0,0,1,0,.91,11.05,11.05,0,0,1-8.79,4.42ZM9,4.09l-.32.21c-4.18,2.73-5.51,8.12-3,12s8,4.82,12.19,2.09c.18-.12.37-.25.54-.39a9.52,9.52,0,0,1-9.29-4.74h0A9.57,9.57,0,0,1,9,4.09Z" />
    </Icon>
  ),
) as IconWithRender;

MoonIcon.displayName = 'MoonIcon';
MoonIcon.renderIcon = (props) => <MoonIcon {...props} />;
export default MoonIcon;
